/* eslint-disable unicorn/filename-case -- TODO rename later */
import { AccessRelation } from "@istari/istari-client";

export enum UserGrantType {
  viewer = "viewer",
  editor = "editor",
  owner = "owner",
  administrator = "administrator",
  executor = "executor",
  upstreamRemoteOwner = "upstreamremoteowner",
  upstreamRemoteEditOwner = "upstreamremoteeditowner",
}

export function userGrantTypeFromAccessRelation(relation: AccessRelation): UserGrantType {
  switch (relation) {
    // The upstream-remote relations' enum values differ from their member keys, so map them explicitly.
    case "upstreamremoteowner":
      return UserGrantType.upstreamRemoteOwner;
    case "upstreamremoteeditowner":
      return UserGrantType.upstreamRemoteEditOwner;
    default:
      return UserGrantType[relation];
  }
}
